import { envConfig } from '@bg-shared/constants/envConfig';

// decorator to avoid calling BE on non-supported environments
export function environmentSpecific(
    _target: unknown,
    _propertyKey: string,
    descriptor: PropertyDescriptor,
) {
    const originalMethod = descriptor.value;
    descriptor.value = async function handle(...args: unknown[]) {
        if (![envConfig.isIntegrationsEnv, envConfig.isProductionEnv].some(Boolean)) {
            return Promise.resolve(null);
        }
        return originalMethod.apply(this, args);
    };
    return descriptor;
}
